<template>
    <v-container class="pa-0 pb-0">
        <v-row class="pt-4">
            <v-col cols="12" md="9">
                <v-text-field
                    v-model="searchText"
                    :label="localize('searchSavedCart')"
                    dense
                    outlined
                    hide-details
                    @keyup="startSearchSavedCart"
                >
                    <fa slot="append" :icon="['fal', 'search']" class="fa-lg" />
                </v-text-field>
            </v-col>
            <v-col cols="12" md="3">
                <v-select
                    v-model="sortSavedCartsByDate"
                    :items="dateSort"
                    :label="localize('sortByDate')"
                    dense
                    outlined
                    color="primary"
                    hide-details
                    @change="sortByDate"
                ></v-select>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="12" class="py-0 pb-2 d-flex justify-end">
                <v-btn
                    small
                    text
                    color="primary"
                    class="px-2"
                    @click="refreshData()"
                >
                    <TranslatableStringComponent :tstring="{string: 'refreshData'}" />
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import _ from 'lodash'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue' 
export default {
    name: 'SearchSavedCarts',
    components: {
        TranslatableStringComponent,
    },
    props: {
        savedCarts: {
            type: Array,
            default: () => [],
        },
        originalSavedCartList: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            searchText: undefined,
            dateSort: [
                { text: this.localize('latest'), value: 'Latest' },
                { text: this.localize('oldest'), value: 'Oldest' },
            ],
            sortSavedCartsByDate: 'Oldest',
        }
    },
    methods: {
        refreshData() {
            this.searchText = undefined
            this.sortSavedCartsByDate = 'Oldest'
            this.$emit('refreshData')
        },
        startSearchSavedCart() {
            this.$emit('startLoading')
            this.searchSavedCarts()
        },
        searchSavedCarts: _.debounce(function () {
            let search = this.searchText.toLowerCase()
            let temp = this.originalSavedCartList
            let filteredSavedCarts = temp.filter((element) => {
                let pn = element.itemData.map((i) => i.pn.toLowerCase())
                let name = element.label?.toLowerCase()
                return (
                    name?.includes(search) ||
                    pn.filter((p) => p.includes(search)).length > 0
                )
            })
            if (this.searchText === '')
                filteredSavedCarts = this.originalSavedCartList
            this.$emit('searchSavedCarts', filteredSavedCarts)
        }, 700),
        sortByDate() {
            this.$emit('startLoading')
            this.sortFunction()
        },
        sortFunction: _.debounce(function () {
            let sortVar = this.sortSavedCartsByDate === 'Latest' ? 1 : -1
            let temp = this.savedCarts.slice()
            let sortedSavedCart = temp.sort((a, b) =>
                b.createdAt > a.createdAt ? 1 * sortVar : -1 * sortVar
            )
            this.$emit('sortByDate', sortedSavedCart)
        }, 700),
    },
}
</script>
